import {FC, memo} from "react";
import {HeaderMenuItemBody, HeaderMenuItemDiv, HeaderMenuItemImg, HeaderMenuItemText} from "./HeaderMenuItemStyle";
import {useNavigate} from "react-router-dom";
import {Icon} from "react-bootstrap-icons";


export interface IMenuItem {
    image?: string,
    name: string,
    link?: string,
}




const HeaderMenuItem: FC<IMenuItem> = (props) => {
    const nav = useNavigate()
    const {image, name, link} = props

    const linkHandle = () => {
        if (link) {
            nav(link)
        }
    }
    return (
        <HeaderMenuItemBody onClick={linkHandle}>
            <HeaderMenuItemDiv>
                <HeaderMenuItemImg src={image}/>
            </HeaderMenuItemDiv>
            <HeaderMenuItemText>{name}</HeaderMenuItemText>
        </HeaderMenuItemBody>
    )
}
export default memo(HeaderMenuItem)
